import { GetDataPath, RowGroupingDisplayType } from 'ag-grid-enterprise';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { TSIconModule } from '../ts-icon';
import { TsTableService } from '../services';
import { TsTableComponent } from '../ts-table/ts-table.component';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'ts-table-grouped',
  templateUrl: './ts-table-grouped.component.html',
  styleUrls: ['../ts-table/ts-table.component.scss'],
  standalone: true,
  imports: [TSIconModule, AgGridAngular, AgGridModule, TsTableComponent, JsonPipe],
})
export class TsTableGroupedComponent extends TsTableComponent implements OnInit {
  @Input() treeData: boolean = false;
  @Input() autoGroupColumnDef: any;
  @Input() groupDisplayType: RowGroupingDisplayType = 'singleColumn';
  @Input() getDataPath!: GetDataPath;

  @Output() rowGroupOpened: EventEmitter<any> = new EventEmitter();

  constructor(tsTableService: TsTableService) {
    super(tsTableService);
  }

  onRowGroupOpened(event: any) {
    this.rowGroupOpened.emit(event);
  }
}
